import { SkillModel } from 'types/models/SkillModel';
import { Skill } from 'types/Project/Skill';

export const mapSkillModelToSkills = (skillModels: SkillModel[]): Skill[] =>
  skillModels.reduce<Skill[]>((acc, { id, name, description }) => (id ? [...acc, { id, name, description }] : acc), []);
